var map = {
	"./interactive-img1.jpg": 327,
	"./interactive-img2.jpg": 328,
	"./interactive-img3.jpg": 329,
	"./interactive-img4.jpg": 330,
	"./interactive-img5.jpg": 331
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 719;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website ^\.\/interactive\-img.*\.jpg$
// module id = 719
// module chunks = 64